import { ScanEyeIcon } from "lucide-react";
import { Slider } from "@primitives/slider";
import { useThemeState } from "@/zustand/ThemeState";
import { useTranslation } from "react-i18next";

export default function RoundedCornersSection() {
  const { t } = useTranslation();
  const { baseBorderRadius, setBaseBorderRadius } = useThemeState();
  return (
    <div className="my-2 py-2">
      <h5 className="mb-2 text-xs font-light text-foreground/50">
        {t("appearance.roundedCorners")}
      </h5>

      <div className="flex gap-2 p-2">
        <ScanEyeIcon />
        <Slider
          value={[baseBorderRadius]}
          onValueChange={(e) => {
            setBaseBorderRadius(e[0]);
          }}
          defaultValue={[0.5]}
          min={-0.2}
          max={1.4}
          step={0.1}
        />
      </div>
    </div>
  );
}
